import { MouseEvent } from 'react';

import { GoogleFontIcon } from '../../icons/GoogleFontIcon';

import styles from './page-header-navigation.module.scss';

export type PageHeaderNavigationProps = {
  label: string;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
};

export function PageHeaderNavigation({
  label,
  onClick,
}: PageHeaderNavigationProps) {
  return (
    <div
      className={styles['root']}
      onClick={onClick}
      data-testid="page-header-navigation"
    >
      <GoogleFontIcon name="chevron_left" /> {label}
    </div>
  );
}
